<template>
  <div>
    <app-popup :active.sync="active" title="Подтверждение">
      <p>Введите слово <b>{{randomWord}}</b> для удаления</p>

      <app-input v-model="confirmWord"/>

      <div style="margin-top: 15px; display: flex; justify-content: center;">
        <app-button :color="acceptColor" @click="accept">{{acceptText}}</app-button>
      </div>

    </app-popup>
  </div>
</template>

<script>
  export default {
    name: "ConfirmWordsPopup",
    props: {
      title: {
        default: 'Подтвержение'
      },
      acceptText: {
        default: 'Удалить'
      },
      acceptColor: {
        default: 'danger'
      }
    },
    data(){
      return {
        active: false,
        words: ['Нептун', 'Уран', 'Сатурн', 'Юпитер', 'Марс', 'Земля', 'Венера', 'Меркурий'],
        confirmWord: "",
        randomWord: null,
      }
    },
    methods: {
      open(){
        this.randomWord = this.words[Math.floor(Math.random() * this.words.length)];
        this.confirmWord = "";
        this.active = true;
      },
      accept(){
        if(this.confirmWord !== null && this.confirmWord.trim() === this.randomWord){
          this.$emit('accept');
          this.active = false;
        }
      }
    }
  }
</script>
